module.exports = __webpack_public_path__ + "navocat.jpg?110fc9e190a947555664b0df135839dc";


//////////////////
// WEBPACK FOOTER
// ./public/creator-avatar/navocat.jpg
// module id = 686
// module chunks = 0